// extracted by mini-css-extract-plugin
export default {"container":"rivet_container__YNEpu"};